
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiimi",
      function () {
        return require("private-next-pages/tiimi/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tiimi"])
      });
    }
  